export const ROUTES = {
	ROOT: "/",
	DASHBOARD: "/dashboard",
	PROFILE: "/profile",
	ACCOUNT: "/account",
	AUTH: "/auth",
	NOT_FOUND: "*",
} as const;

export type RouteType = (typeof ROUTES)[keyof typeof ROUTES];
